import React, { useEffect, useState } from "react";
import {
  GenericTable,
  Pagination,
  SearchableDropdown,
} from "../../../Components/Common";
import { useStock } from "../Hooks/useStock";
import {
  STOCK_COLUMNS,
  STOCK_LABELS,
} from "../constants";
import { useWarehouse } from "../Hooks/useWarehouse";
import { useProductMaster } from "../Hooks/useProductMaster";

const StockList = () => {
  const {
    loading,
    filters,
    page,
    onPageChange,
    onPageSizeChange,
    totalPages,
    rowsPerPage,
    setFilters,
    fetchStocks,
  } = useStock();
  const { fetchWarehouses } = useWarehouse();
  const { fetchProducts } = useProductMaster();

  const [stocks, setStocks] = useState([]);

  const fetchData = async () => {
    const data = await fetchStocks();
    if (data) setStocks(data);
  };

  const renderField = (column, row) => {
    switch (column) {
      case "product":
        return row.product?.product_name || "";
      case "warehouse":
        return row.warehouse?.name || "";
      case "UOM":
        return row.product?.UOM_name || "";
      case "available_quantity":
        return `${row.available_quantity || 0}`;  
      default:
        return row[column] || "N/A";
    }
  };

  const renderMobileCard = (row) => (
    <div className="p-2">
      <div className="bg-white shadow-lg rounded-2xl border border-gray-200 overflow-hidden relative">
        <div className="p-4 flex flex-col space-y-2 w-[80%]">
          <div className="text-lg font-semibold text-gray-800 truncate">
            {row.product?.product_name || "N/A"}
          </div>
          <div className="text-gray-600 text-sm truncate">
            {row.warehouse?.name || "N/A"}
          </div>
        </div>
        <div className="absolute bottom-3 right-4 bg-gray-100 px-3 py-1 rounded-full text-sm font-medium text-gray-800 shadow-inner">
          {row.available_quantity || 0} {row.product?.UOM || "Units"}
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    fetchData();
  }, [filters, page, totalPages, rowsPerPage]);

  return (
    <div className="py-6 px-4">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-semibold text-gray-800 mb-4">
          Stock Management
        </h1>
      </div>
      <div className="bg-white w-full rounded-2xl shadow-md border px-4 py-3">
        <div className="flex flex-wrap gap-2">
          <SearchableDropdown
            fetchFunction={fetchWarehouses}
            onSelect={(val) =>
              setFilters({ ...filters, warehouse: val })
            }
            valueKey="id"
            labelKey="name"
            includeAllOption
            allOptionLabel="All Warehouses"
            placeholder="Select Warehouse"
            width="[35%]"
          />

          <SearchableDropdown
            fetchFunction={fetchProducts}
            onSelect={(val) =>
              setFilters({ ...filters, product: val === "" ? null : val })
            }
            valueKey="id"
            labelKey="product_name"
            includeAllOption
            allOptionLabel="All Products"
            placeholder="Select Product"
            width="[35%]"
          />
        </div>
      </div>
      <div className="py-2">
          <>
            <div className="h-[60vh] overflow-y-auto">
              {loading ? (
                <div className="h-full w-full flex justify-center items-center">
                  <div className=" animate-spin border-t border-blue-600"></div>
                </div>
              ) : (
                <GenericTable
                  tableColumns={STOCK_COLUMNS}
                  tableRows={stocks}
                  columnLabels={STOCK_LABELS}
                  renderField={renderField}
                  renderMobileCard={renderMobileCard}
                />
              )}
            </div>
            <div className="shrink-0 mt-2">
              <Pagination
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={onPageChange}
                onPageSizeChange={onPageSizeChange}
                totalPages={totalPages}
              />
            </div>
          </>
      </div>
    </div>
  );
};

export default StockList;
